class SearchView {
  _parentElement = document.querySelector('.search');
  _searchInputField = this._parentElement.querySelector('.search__field');

  addHandlerSearch(handler) {
    this._parentElement.addEventListener('submit', function (event) {
      event.preventDefault();
      handler();
    });
  }

  getQuery() {
    const query = this._searchInputField.value;
    this._clearInput();
    return query;
  }

  _clearInput() {
    this._searchInputField.value = '';
  }
}

export default new SearchView();
